module.exports = __webpack_public_path__ + "img/EcommerceExpress.d02928f9.svg";